var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-5 0 266 266",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00B5DE",
    points: "256.002409 25.5228988 127.614494 25.5228988 109.825807 53.3660612 202.636348 110.599228 202.636348 110.599228 202.636348 110.599228"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00DECC",
    points: "109.825807 53.3660612 23.9760565 0 23.9760565 128.387915 54.1394824 145.403181 202.636348 110.599228 202.636348 110.599228"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5529",
    points: "230.479511 136.895548 202.636348 119.880282 145.403181 211.917402 230.479511 265.283464"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF9640",
    points: "202.636348 119.880282 202.636348 119.880282 202.636348 119.880282 53.3660612 155.457656 0 238.987144 128.387915 238.987144 145.403181 211.917402"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModx);
export default __webpack_public_path__ + "static/media/logo-modx.15cc671f8e9c21e0d30eb9032acf22ce.svg";
export { ForwardRef as ReactComponent };